import Color from '@/Enums/Color.enum';
import SearchIcon from '@/components/Icons/SearchIcon';
import StyledInput from '@/components/TabSelect/styled/StyledInput';
import { Button } from '@mui/material';
import classNames from 'classnames';
import type { ChangeEvent } from 'react';

interface IProps {
  label: string;
  total: number;
  search: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onClear: () => void;
  hasNoMatch: boolean;
  className?: string;
}

const ProductInventorySearch = ({ label, total, search, onChange, onClear, hasNoMatch, className }: IProps) => (
  <div className={classNames('flex flex-col', className)}>
    <StyledInput
      fullWidth
      startAdornment={<SearchIcon className={`text-[${Color.Grey}]`} />}
      placeholder={`Search ${total} ${label}`}
      value={search}
      onChange={onChange}
      sx={{ padding: '0 7px 0 16px' }}
    />
    {hasNoMatch && (
      <div className='flex flex-col items-start gap-1 px-3 py-6'>
        <p className='text-[15px] font-semibold text-[#303030]'>
          No {label} match “{search.trim()}”
        </p>
        <Button
          variant='text'
          onClick={onClear}
          sx={{ p: 0, minWidth: 0, fontSize: '14px', textDecoration: 'underline', color: Color.Primary }}
        >
          Clear search
        </Button>
      </div>
    )}
  </div>
);

export default ProductInventorySearch;
